/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentsCreate } from "../funcs/agents-create.js";
import { agentsDelete } from "../funcs/agents-delete.js";
import { agentsGet } from "../funcs/agents-get.js";
import { agentsList } from "../funcs/agents-list.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import * as agents from "../models/agents/index.js";
import * as interactions from "../models/interactions/index.js";
import {
  CreateAgentParams,
  DeleteAgentParams,
  GetAgentParams,
  ListAgentsParams,
} from "../models/operations/method-params.js";
import { APIPromise, unwrapAsAPIPromise } from "../types/async.js";

export class Agents extends ClientSDK {
  /**
   * Creates a new Agent (Typed version for SDK).
   */
  create(
    params: CreateAgentParams,
    options?: RequestOptions,
  ): APIPromise<agents.Agent> {
    const { api_version, ...body } = params;
    return unwrapAsAPIPromise(agentsCreate(
      this,
      body,
      api_version,
      options,
    ));
  }

  /**
   * Lists all Agents.
   */
  list(
    params?: ListAgentsParams,
    options?: Omit<RequestOptions, "extra_body">,
  ): APIPromise<agents.AgentListResponse> {
    return unwrapAsAPIPromise(agentsList(
      this,
      params?.api_version,
      params?.page_size,
      params?.page_token,
      params?.parent,
      options,
    ));
  }

  /**
   * Gets a specific Agent.
   */
  get(
    id: string,
    params?: GetAgentParams,
    options?: Omit<RequestOptions, "extra_body">,
  ): APIPromise<agents.Agent> {
    return unwrapAsAPIPromise(agentsGet(
      this,
      id,
      params?.api_version,
      options,
    ));
  }

  /**
   * Deletes an Agent.
   */
  delete(
    id: string,
    params?: DeleteAgentParams,
    options?: Omit<RequestOptions, "extra_body">,
  ): APIPromise<interactions.Empty> {
    return unwrapAsAPIPromise(agentsDelete(
      this,
      id,
      params?.api_version,
      options,
    ));
  }
}
